<template>
  <div class="w-100">
    <basic-subheader>
      <template v-slot:actions>
        <b-row class="align-items-center flex-nowrap">
          <b-col cols="auto" class="pr-2">
            <b-dropdown
              id="dropdown-right dropdown-form"
              class="dropdown-form-filter"
              no-caret
              right
            >
              <template #button-content>
                <span class="svg-icon">
                  <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
                </span>
                Bộ lọc
              </template>
              <h6 class="d-flex align-items-center mb-0 p-4">
                <span class="svg-icon mr-3">
                  <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
                </span>
                Bộ lọc
              </h6>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-form>
                <b-container class="p-0">
                  <b-row class="mb-3">
                    <b-col cols="4">
                      <basic-input
                        label="Tên khách hàng"
                        placeholder="Nhập tên khách hàng"
                        name="patientName"
                        :value.sync="patientName"
                      />
                    </b-col>
                    <b-col cols="4">
                      <basic-select
                        label="Loại hoạt động"
                        placeholder="Chọn loại hoạt động"
                        name="activity-type"
                        data-vv-as="Loại hoạt động"
                        track-by="Id"
                        value-label="Name"
                        :value.sync="selectedActivityType"
                        :options="activityTypes"
                        @input="onActivityTypeSelect"
                      />
                    </b-col>
                    <b-col cols="4">
                      <basic-date-picker
                        :value.sync="selectedDate"
                        label="Chọn ngày"
                        placeholder="Chọn ngày"
                        name="selectedDate"
                        data-vv-As="Chọn ngày"
                        format="YYYY-MM-DD HH:MM:SS"
                      />
                    </b-col>
                    <b-col cols="4">
                      <basic-date-picker
                        :value.sync="selectedDate"
                        label="Chọn ngày"
                        placeholder="Chọn ngày"
                        name="selectedDate"
                        data-vv-As="Chọn ngày"
                        format="YYYY-MM-DD HH:MM:SS"
                      />
                    </b-col>
                    <b-col cols="4">
                      <basic-select
                        label="Trạng thái"
                        placeholder="Chọn trạng thái"
                        name="status"
                        data-vv-as="Trạng thái"
                        track-by="value"
                        value-label="text"
                        :value.sync="selectedStatus"
                        :options="statusOptions"
                        @input="onStatusSelect"
                      />
                    </b-col>
                  </b-row>
                </b-container>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <div
                class="d-flex align-items-center justify-content-lg-end m-0 p-4"
              >
                <b-button
                  class="btn ml-2"
                  href="#"
                  tabindex="0"
                  @click="onResetFilterDashboard"
                >
                  <span class="svg-icon">
                    <inline-svg
                      src="/media/svg/icons/Neolex/Basic/refresh-cw.svg"
                    />
                  </span>
                  Reset bộ lọc
                </b-button>
                <b-button
                  class="btn ml-2"
                  href="#"
                  tabindex="0"
                  @click="onApplyFilterDashboard"
                >
                  <span class="svg-icon">
                    <inline-svg
                      src="/media/svg/icons/Neolex/Basic/filter.svg"
                    />
                  </span>
                  Lọc dữ liệu
                </b-button>
              </div>
            </b-dropdown>
          </b-col>

          <b-col cols="auto" class="pl-2">
            <b-button class="btn btn-success" @click="openCoachModal">
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/search.svg" />
              </span>
              Chọn Coach
            </b-button>
          </b-col>

          <b-col cols="auto" class="pl-2">
            <b-button variant="success" @click="onApplyFilterDashboard">
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/refresh-cw.svg" />
              </span>
              Cập nhật
            </b-button>
          </b-col>


        </b-row>
      </template>
    </basic-subheader>



    <tracking-calendar
      v-if="userPackages.length > 0"
      :user-packages="userPackages"
      :activity-types="activityTypes"
      :selected-service-package="selectedServicePackage"
      :service-packages="servicePackages"
      :selected-date ="selectedDate"
      :coach-id="selectedCoach ? selectedCoach.value : ''"
    />
    <select-coach-modal
      :currentUser="currentUser"
      @selected-success="onCoachModalSelected"
    />
  </div>
</template>
<script>
import TrackingCalendar from './components/TrackingCalendar.vue';
import { mapGetters } from 'vuex';


export default
{
    components: {
      TrackingCalendar,
      'select-coach-modal': () => import('./components/SelectCoachModal.vue'),
    },
    data() {
        return {
            selectedCoach: null,
            patientName: null,
            selectedServicePackage: null,
            selectedActivityType: null,
            selectedStatus: null,
            selectedDate: null,
            coaches: [],
            userPackages: [],
            activityTypes: [],
            servicePackages: [],
            servicePackageOptions: [],
            statusOptions: [
                { text: 'Chưa hoàn thành', value: 0 },
                { text: 'Đã hoàn thành', value: 1 },
            ],
        };
    },
    async created() {
        this.getSetupList();
    },
    computed: {
        ...mapGetters(['currentUser']),
        loading() {
            return this.$store.getters['context/loading'];
        },
    },
    methods: {
    selected(value, formProperty, optionsArr) {
        this[formProperty] = optionsArr.find((el) => el.value === value) || null;
    },
    openCoachModal() {
        this.$bvModal.show('dashboard-coach-modal');
    },
    onCoachModalSelected({ coachSelected, servicePackageSelected }) {
        this.selectedCoach = coachSelected;
        this.selectedServicePackage = servicePackageSelected?.value || null;
        this.GetUserPackagesAssignedToCoach();
    },
    onActivityTypeSelect(value) {
        this.selectedActivityType = value;
    },
    onStatusSelect(value) {
        this.selectedStatus = value;
    },
    onApplyFilterDashboard() {
        this.GetUserPackagesAssignedToCoach();
        document.body.click();
      
    },
    onResetFilterDashboard() {
        this.selectedActivityType = null;
        this.selectedServicePackage = null;
        this.selectedStatus = null;
        this.selectedDate = null;
        this.patientName = null;
        this.selectedCoach = null;
        this.GetUserPackagesAssignedToCoach();
        document.body.click();
    },
    onApplyFilter(filters) {
        this.selectedActivityType = filters.selectedActivityType;
        this.selectedServicePackage = filters.selectedServicePackage;
        this.selectedStatus = filters.selectedStatus;
        this.GetUserPackagesAssignedToCoach();
    },
    onResetFilter() {
        this.selectedActivityType = null;
        this.selectedServicePackage = null;
        this.selectedStatus = null;
        this.GetUserPackagesAssignedToCoach();
    },
    convertDateToTimestamp(date) {
      if (!date) return null;
      return Math.floor(new Date(date).getTime() / 1000);
    },

    async GetUserPackagesAssignedToCoach() {
      this.$store.commit('context/setLoading', true);
      try {
        const params = new URLSearchParams();
        if(this.selectedCoach) {
          params.append('coachId', this.selectedCoach.value);
        }
        if (this.selectedServicePackage) {
          params.append('servicePackageId', this.selectedServicePackage);
        }
        if (this.selectedActivityType) {
          params.append('activityTypeId', this.selectedActivityType);
        }
        if (this.selectedStatus !== null) {
          params.append('status', this.selectedStatus);
        }
        if(this.selectedDate !== null) {
          params.append('date', this.convertDateToTimestamp(this.selectedDate));
        }
        if(this.patientName) {
          params.append('patientName', this.patientName);
        }
        const url = `/TranUserPackage/Coach?${params.toString()}`;
        const data  = await this.$api.get(url);
          this.userPackages = data || [];
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
        return Promise.reject(error);
      } finally {
        this.$store.commit('context/setLoading', false);
        this.$toastr.s({
          title: 'Thành công',
          msg: 'Tải dữ liệu thành công',
        });
      }
    },
    async getSetupList () {
      this.$store.commit('context/setLoading', true);
      try {
        var {data} = await this.$api.get(`/ProgramActivityLevel/setup-list`);
        this.activityTypes = data.Types || [];
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    }

}}
</script>

<style scoped>
::v-deep .dropdown-form-filter .dropdown-menu {
  width: 700px;
}

.svg-icon {
  display: inline-block;
  margin-right: 0.5rem;
  width: 16px;
  height: 16px;
}

.dropdown-form-filter {
  .dropdown-menu {
    .container {
      width: 700px;
    }
  }
}
</style>